export default __webpack_public_path__ + "static/media/ic-logout.65d71855.svg";